import { sendAmplitudeData, sendAmplitudeRevenue, setAmplitudeUserId } from './amplitude';
import { sendGismartData } from './gismart';
import { sendLockerStudioData } from './lockerStudio';
import gismartEvents from './gismartEvents';
import { PLANS } from './eCommerce';
import ReactGA from 'react-ga4';
import { REACT_APP_GOOGLE_TRACKING_ID, REACT_APP_GOOGLE_ADS_ID } from './GA';

const isStage = process.env.REACT_APP_ENV === 'stage';

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
    const gismartEventName = gismartEvents[eventName];

    sendAmplitudeData(eventName, eventParams);
    sendGismartData(gismartEventName || eventName, eventParams);
    sendLockerStudioData(gismartEventName || eventName, eventParams);
    pushGoogleTag(eventName, eventParams);
};

export const sendRevenueEvent = plan => {
    let eventParams = PLANS[plan];
    sendAmplitudeRevenue(eventParams);
};

export const setAnalyticsUserId = (userId = '') => {
    setAmplitudeUserId(userId);
};

export const pushGoogleTag = (eventName, eventParams, tagId = REACT_APP_GOOGLE_TRACKING_ID) => {
    if (isStage) return;
    ReactGA.event(eventName, { ...eventParams, send_to: tagId });
};

export const pushFBEvent = (data, eventId) => {
    if (window.fbq) {
        window.fbq('track', 'Purchase'+(isStage ? '_test' : ''), data, {eventID: eventId});
    }
};

export const sendPurchaseEvent = (
  price,
  currency,
  plan,
  sub_id,
  event_id,
  gclid = '',
  pixelName
) => {
    if (pixelName === 'fb') {
      pushFBEvent(
        {
          currency: currency || 'USD',
          itemCount: 1,
          transactionId: sub_id,
          price: price,
          value: price,
        },
        event_id
      );
    } else if ('ttq') {
      window?.ttq?.track('CompletePayment', {
        value: price,
        currency: currency || 'USD',
        contents: [
          {
            content_type: 'product',
            content_name: plan,
          },
        ],
        event_id,
      });
    }
    pushGoogleTag(
      'purchase',
      {
        currency: currency || 'USD',
        value: price,
        transaction_id: sub_id,
        gclid,
        items: {
            item_id: plan,
            item_name: plan,
        },
      }
    );
    pushGoogleTag(
      'conversion',
      {
        value: price,
        currency: currency || "USD",
        transaction_id: sub_id,
      },
      REACT_APP_GOOGLE_ADS_ID
    );
};
